import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {PaymentMethod} from '../../model/payment.model';

export interface PaymentRefundParams {
  invoiceId: string;
  type: PaymentMethod;
}

export interface PaymentRoute {
  getParams(): Observable<PaymentRefundParams>;
}

export const PAYMENT_ROUTE = new InjectionToken<PaymentRoute>('PAYMENT_ROUTE');
